// A GEOMETRIA da trilha: onde o fim de leva cai, e onde uma carta comum PODE
// cair. Não diz onde ela cai — isso é sorteio, e mora em ./recompensaDaFase.js.
//
// A regra do fim de leva (decisão I-2/I-3) não mudou desde o começo: card RARO na
// última fase de cada leva, o que faz qualquer atividade, de 1 a N itens, terminar
// com a cerimônia do arco. A garantia não depende de o professor ter usado o
// tamanho "ideal".
//
// ---------------------------------------------------------------------------
// A CARTA COMUM DEIXOU DE TER POSIÇÃO FIXA (24/08/2026)
// ---------------------------------------------------------------------------
// Até aqui esta função devolvia `comuns`: as posições PARES de cada leva. Era
// geometria pura, e tinha duas consequências que só apareceram com trilha longa:
//
// 1. uma carta a cada dois nós. Numa trilha de 39 fases isso é 18 das 20 comuns da
//    região — 90% do banco de uma vez — e a segunda trilha do aluno não tinha mais
//    quase nada de novo para dar. Medido: o aluno mais ativo de homologação já tinha
//    a coleção do Nordeste COMPLETA em 24/08/2026;
// 2. o aluno decorava o lugar. Carta em 2, 4, 7, 9 — em duas trilhas não há surpresa
//    nenhuma.
//
// Hoje a geometria diz onde a carta PODE cair (`elegiveis` = tudo que não é fim de
// leva) e o sorteio estratificado escolhe QUAIS dessas fases recebem. Quantas
// recebem é `QUANTAS_COMUNS`, em ./recompensaDaFase.js.
//
// Por que `elegiveis` é "tudo menos o fim de leva", e não uma lista mais curta: o
// fim de leva já entrega a cena do arco, e empilhar uma comum ali seria duas
// cerimônias no mesmo nó. Fora isso, nenhuma fase é proibida — inclusive a vizinha
// do fim de leva (decisão 9 do plano: proibi-la deixaria uma trilha de 8 fases com
// UMA posição possível, ou seja, sem sorteio nenhum). A fase 1 também não é
// proibida por regra: a janela do jitter já a deixa de fora por construção (ver
// JITTER_DA_POSICAO).

import { fimDaLeva, totalDeLevas } from "./motorFases";

/**
 * @param {number} totalFases
 * @returns {{elegiveis: number[], raras: number[]}} números de fase (1-based).
 *   `raras` são os fins de leva; `elegiveis`, todas as outras.
 */
export function distribuicaoDeRecompensas(totalFases) {
  const elegiveis = [];
  const raras = [];

  if (!totalFases || totalFases <= 0) return { elegiveis, raras };

  const levas = totalDeLevas(totalFases);
  let inicio = 1;

  for (let leva = 1; leva <= levas; leva += 1) {
    const fim = fimDaLeva(leva, totalFases);

    for (let fase = inicio; fase <= fim; fase += 1) {
      if (fase === fim) {
        raras.push(fase);
      } else {
        elegiveis.push(fase);
      }
    }

    inicio = fim + 1;
  }

  return { elegiveis, raras };
}

export function ehFaseRara(fase, totalFases) {
  return distribuicaoDeRecompensas(totalFases).raras.includes(fase);
}

// `ehFaseComRecompensa` saiu em 24/08/2026, junto com a posição fixa. A pergunta
// que ela respondia — "esta fase premia?" — deixou de ter resposta na geometria:
// depende do sorteio guardado, e quem responde é `faseEntregaCarta`
// (./recompensaDaFase.js). Manter as duas era garantir que uma delas mentisse.
